/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MapObjectViewDto } from './mapObjectViewDto';
import { PhotoDataLoyaltyView } from './photoDataLoyaltyView';


export interface SearchedLoyaltyProductViewDto { 
    /**
     * Уникальный идентификатор объявления
     */
    id: string;
    /**
     * Наименование продукта лояльности
     */
    name: string;
    /**
     * Описание продукта лояльности
     */
    description: string;
    /**
     * Краткое описание продукта лояльности
     */
    descriptionShort?: string;
    /**
     * Статус продукта
     */
    status: number;
    /**
     * Сортировка задаваемая вручную
     */
    sortOrder?: number;
    /**
     * Признак рекламного объявления
     */
    isAdvertisment: boolean;
    /**
     * ID организации продукта
     */
    organisationId?: string;
    /**
     * ID ассоциации
     */
    parentOrganisationId?: string;
    /**
     * Информация о компании
     */
    organisationInfo: string;
    /**
     * Краткое наименование организации
     */
    organisationShortName?: string;
    /**
     * Полное наименование организации
     */
    organisationFullName?: string;
    /**
     * ID обложки организации
     */
    organisationLogoId?: string;
    externalAuthorId?: string;
    externalOrganisationId?: string;
    externalOrganisationName?: string;
    externalOrganisationLogoId?: string;
    /**
     * текст скидки.
     */
    discountText?: string;
    /**
     * Адреса с координатами
     * @deprecated
     */
    mapObjects?: Array<MapObjectViewDto>;
    /**
     * Список фотографий
     */
    photos?: Array<PhotoDataLoyaltyView>;
    /**
     * Признак, что объявление в списке отмеченных пользователем
     */
    isFavorite?: boolean;
}

